var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalGraph(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    width: 11.5,
    height: 13.5,
    viewBox: "0 0 11.5 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1141.75 -382.75)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 8,
    transform: "translate(1142.5 387.5)"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 12,
    transform: "translate(1147.5 383.5)"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 5,
    transform: "translate(1152.5 390.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalGraph);
export default __webpack_public_path__ + "static/media/verticalGraph.7f1cb088fd6295d37113a133380ed3a8.svg";
export { ForwardRef as ReactComponent };